import { ReactNode } from 'react';
import { ConfigProvider } from 'antd';

import '../../pages/CamProgramming/embed/embed.css';

type Props = { children: ReactNode };

/** Minimal chrome for pages embedded in external hosts (e.g. Fusion 360). */
export default function EmbedLayout({ children }: Props) {
	// Hosts like the Fusion palette give us a sliver of a window, so controls
	// default to their compact size here rather than being marked one by one.
	// The theme from the app root is inherited; only the size is added.
	return (
		<ConfigProvider componentSize="small">
			<div className="embed-layout">
				<main className="embed-layout__main">{children}</main>
			</div>
		</ConfigProvider>
	);
}
